import type from './uploader.type';

const initialState = {
  queueFiles: null,
  queueSummary: null,
  lastCompleted: null,
};

const UploaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.ADD_FILES_IN_QUEUE_UPLOADER:
      return {
        ...state,
        queueFiles: { ...state.queueFiles, ...action.payload },
      };
    case type.UPLOADFILE_PERCENTAGE_STATUS:
      const updatePercentage = state.queueFiles;
      if (!updatePercentage?.[action.payload.taskId]) {
        return state;
      }
      updatePercentage[action.payload.taskId].percentage = action.payload.filePercentage;
      if (action.payload.filePercentage === 100) {
        updatePercentage[action.payload.taskId].completed = true;
      }
      return {
        ...state,
        queueFiles: { ...state.queueFiles, ...updatePercentage },
      };
    case type.UPDATE_CROPPED_IMAGE_LOADER:
      const updateCroppedImageStatus = state.queueFiles;
      if (!updateCroppedImageStatus?.[action.payload.taskId]) {
        return state;
      }
      updateCroppedImageStatus[action.payload.taskId].isCroppedImageLoader = action.payload.isCroppedImageLoader ? action.payload.isCroppedImageLoader : false;
      updateCroppedImageStatus[action.payload.taskId].isThumbnailImageLoader = action.payload.isThumbnailImageLoader
        ? action.payload.isThumbnailImageLoader
        : false;

      return {
        ...state,
        queueFiles: { ...state.queueFiles, ...updateCroppedImageStatus },
      };
    case type.SET_UPLOADER_QUEUE_SUMMARY:
      return {
        ...state,
        queueSummary: action.payload,
      };
    case type.UPLOAD_COMPLETED_PING:
      return {
        ...state,
        lastCompleted: {
          module: action.payload?.module || null,
          devOrderId: action.payload?.devOrderId || null,
          seq: (state.lastCompleted?.seq || 0) + 1,
        },
      };
    case type.CLEAR_UPLOADER_FILES:
      return {
        ...state,
        queueFiles: null,
        queueSummary: null,
      };
    case type.REMOVE_TASK_FROM_LIST:
      const cloneQueueFiles = { ...state.queueFiles };
      if (action.payload in cloneQueueFiles) {
        delete cloneQueueFiles[action.payload];
      }
      return {
        ...state,
        queueFiles: cloneQueueFiles,
      };

    default:
      return state;
  }
};

export default UploaderReducer;
